import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IArchivingSettingsFormMeta {
  id: FormInputMeta;
  label: FormInputMeta;
  nbDays: FormInputMeta;
  isChecked: FormInputMeta;

  schema: any;
}

const archivingSettingFormMeta = {} as IArchivingSettingsFormMeta;

archivingSettingFormMeta.id = {
  name: "id",
  type: "text",
  label: "Id.",
  placeholder: "Veuillez entrer l'Id svp...",
  validation: yup.string().required("Champ obligatoire !")
};

archivingSettingFormMeta.label = {
  name: "label",
  type: "text",
  label: "Label",
  placeholder: "Veuillez entrer le Label svp...",
  validation: yup.string().required("Champ obligatoire !")
};

archivingSettingFormMeta.nbDays = {
  name: "nbDays",
  type: "number",
  label: "Nb. Days",
  placeholder: "Veuillez entrer l'Id",
  validation: yup.number().required("Champ obligatoire !")
};

archivingSettingFormMeta.isChecked = {
  name: "isChecked",
  type: "checkbox",
  label: "isChecked",
  placeholder: "",
  validation: yup.boolean()
};


archivingSettingFormMeta.schema = yup.object().shape(getValidationSchema(archivingSettingFormMeta));

export default archivingSettingFormMeta;